import { Heading, Page, Paragraph, TextButton } from '@zillow/constellation-10';

import UnsubscribeError from 'app/shared/components/UnsubscribeError';

type UnsubscribeViewProps = {
  email: string;
  address: string | null;
  isSubscribed: boolean | null;
  isErrored: boolean;
  onUndo: () => void;
};

const UnsubscribeView = ({ email, address, isSubscribed, isErrored, onUndo }: UnsubscribeViewProps) => {
  return (
    <Page.Root
      css={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'bg.screen.neutral',
      }}
    >
      <Page.Content css={{ paddingBottom: '1500' }}>
        {isErrored ? (
          <UnsubscribeError />
        ) : (
          <>
            <Heading level={1} textStyle="heading-lg" fontFamily="heading-alt" css={{ marginTop: '800' }}>
              Thank you!
            </Heading>
            <Heading level={2} textStyle="body-lg-bold" css={{ marginTop: '600' }}>
              You have been {isSubscribed ? 'subscribed to' : 'unsubscribed from'} the Rental Marketplace Update
            </Heading>
            <Paragraph css={{ marginTop: '400' }}>
              Property: <strong>{address}</strong>
            </Paragraph>
            <Paragraph css={{ marginTop: '400' }}>
              Email address: <strong>{email}</strong>
            </Paragraph>
            <Paragraph css={{ marginTop: '400' }}>
              <TextButton onClick={onUndo} textStyle="body-bold">
                Undo
              </TextButton>
            </Paragraph>
          </>
        )}
      </Page.Content>
    </Page.Root>
  );
};

export default UnsubscribeView;
